import { Component , HostBinding } from '@angular/core';
import { HeaderComponent } from '../shared/header.component';
import { FooterComponent } from '../shared/footer.component';

@Component({
  selector: 'app-terms',
  templateUrl: './terms.component.html',
  styleUrls: ['./terms.component.css'],
  host: {'class': 'd-flex flex-column h-100 ipadfooterbottom'},
  standalone: true,
  imports: [HeaderComponent, FooterComponent ]
})
export class TermsComponent {

  @HostBinding('style.width') public readonly WIDTH = '100%';

  title = 'webapp';
  scrollToElement($element: any): void {
    console.log($element);
    $element.scrollIntoView({behavior: 'smooth', block: 'start', inline: 'nearest'});
  }
}


